import React, { useState, useLayoutEffect } from 'react'
import useData from '../hooks/useData'
import Loading from './Loading'
import Icon from './Icon'
import CompetitorLinkList from './CompetitorLinkList'
import history from '../modules/history'
import ArticleResourcesContent from './ArticleResourcesContent'
import ArticleResourcesColumn from './ArticleResourcesColumn'
import URI from 'urijs'
import Input from './Input'
import InspectUrl from './InspectUrl'
import PageListTitle from './PageListTitle'
import PageListDate from './PageListDate'

const sortPages = (a, b) => b.lastmod.localeCompare(a.lastmod)

const CompetitorView = props => {
    const id = props.id || (props.match && props.match.params && props.match.params.id) || false
    const article_id = props.article_id || (props.match && props.match.params && props.match.params.article_id) || false
    const competitor = useData('competitor/' + id)
    const pageArray = useData('competitor_page/?competitor_id=' + id)
    const [competitorLinkPageList, setCompetitorLinkPageList] = useState([])
    const [competitorInspectPageList, setCompetitorInspectPageList] = useState([])
    const query = URI.parseQuery(props.location.search)
    const target_url = query['url']
    useLayoutEffect(() => {
        const candidate = pageArray.isReady && pageArray.data.find(p => p.url === target_url)
        target_url && candidate && pageArray.isReady && setCompetitorInspectPageList([...competitorLinkPageList, candidate.id])
    }, [pageArray.isReady])

    const toggleLink = page_id => {
        if (~competitorLinkPageList.indexOf(page_id)) {
            setCompetitorLinkPageList([...competitorLinkPageList.filter(p => p != page_id)])
        } else {
            setCompetitorLinkPageList([...competitorLinkPageList, page_id])
        }
    }
    const toggleInspect = page_id => {
        if (~competitorInspectPageList.indexOf(page_id)) {
            setCompetitorInspectPageList([...competitorInspectPageList.filter(p => p != page_id)])
        } else {
            setCompetitorInspectPageList([...competitorInspectPageList, page_id])
        }
    }

    // const onArticleChange = article_id => {
    //     history.push(`/competitor/view/${id}${(article_id && '/' + article_id) || ''}`)
    // }

    return (
        <>
            {(competitor.isReady && pageArray.isReady && (
                <>
                    <ArticleResourcesContent>
                        <div className='row'>
                            <div className={'col-md-9 col-xxl-7'}>
                                <h2>{competitor.data.label}</h2>
                                <p>
                                    {competitor.data.url}
                                    <br />
                                    {pageArray.data.length} pages
                                </p>
                                <table className='table'>
                                    <tbody>
                                        {pageArray.isReady &&
                                            pageArray.data.sort(sortPages).map(page => (
                                                <React.Fragment key={`page-row-${page.id}`}>
                                                    <tr>
                                                        <td>
                                                            <PageListTitle {...page} />
                                                        </td>
                                                        <td className='text-right'>
                                                            <PageListDate {...page} />
                                                        </td>
                                                        <td className='text-right'>
                                                            {(page.affiliate_links && (
                                                                <button onClick={() => toggleLink(page.id)} className={'btn btn-primary btn-xs mr-1' + ((~competitorLinkPageList.indexOf(page.id) && ' active') || '')} aria-pressed={(~competitorLinkPageList.indexOf(page.id) && 'true') || 'false'}>
                                                                    <Icon name='amazon' /> {page.affiliate_links} products {(~competitorLinkPageList.indexOf(page.id) && <Icon name='angle-up' />) || <Icon name='angle-down' />}
                                                                </button>
                                                            )) ||
                                                                null}
                                                            <button onClick={() => toggleInspect(page.id)} className={'btn btn-primary btn-xs mr-1' + ((~competitorInspectPageList.indexOf(page.id) && ' active') || '')} aria-pressed={(~competitorInspectPageList.indexOf(page.id) && 'true') || 'false'}>
                                                                Inspect {(~competitorInspectPageList.indexOf(page.id) && <Icon name='angle-up' />) || <Icon name='angle-down' />}
                                                            </button>
                                                        </td>
                                                    </tr>
                                                    {(~competitorLinkPageList.indexOf(page.id) && (
                                                        <tr>
                                                            <td colSpan='3'>
                                                                <CompetitorLinkList {...page} competitor_page_id={page.id} reviews={true} origin={'competitor'} originalUrl={page.url} displayUrl={URI(page.url).protocol() + '://' + URI(page.url).hostname()} />
                                                            </td>
                                                        </tr>
                                                    )) ||
                                                        null}
                                                    {(~competitorInspectPageList.indexOf(page.id) && (
                                                        <tr>
                                                            <td colSpan='3'>
                                                                <InspectUrl url={page.url} origin="competitor" originalUrl={page.url} displayUrl={URI(page.url).protocol() + '://' + URI(page.url).hostname()} target_article={!!article_id} />
                                                            </td>
                                                        </tr>
                                                    )) ||
                                                        null}
                                                </React.Fragment>
                                            ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className={'col-md-3 col-xxl-5'}><ArticleResourcesColumn grabText={true} origin={'competitor'} originalUrl={competitor.data.url} displayUrl={competitor.data.url} /></div>
                        </div>
                    </ArticleResourcesContent>
                </>
            )) || <Loading text='Fetching competitor data' />}
        </>
    )
}

export default CompetitorView
